import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { persistTabState } from 'features/knowledgeDocumentViewer/utils/documentPageSessionStorage'
import { type MutableRefObject, useEffect } from 'react'

/** Debounced writes, plus a pagehide/unmount flush so reload keeps live tab state. */
export function useWorkspaceTabPersistence({
  storageOwnerRef,
  scope,
  openTabs,
  activeTabId,
  scopeRef,
  openTabsRef,
  activeTabIdRef,
}: {
  storageOwnerRef: MutableRefObject<string | null>
  scope: string
  openTabs: DocumentTab[]
  activeTabId: string
  scopeRef: MutableRefObject<string>
  openTabsRef: MutableRefObject<DocumentTab[]>
  activeTabIdRef: MutableRefObject<string>
}): void {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      persistTabState(storageOwnerRef.current, scope, openTabs, activeTabId)
    }, 300)
    return () => window.clearTimeout(timer)
  }, [activeTabId, openTabs, scope, storageOwnerRef])

  useEffect(() => {
    const persist = () => {
      persistTabState(
        storageOwnerRef.current,
        scopeRef.current,
        openTabsRef.current,
        activeTabIdRef.current
      )
    }
    window.addEventListener('pagehide', persist)
    return () => {
      window.removeEventListener('pagehide', persist)
      persist()
    }
  }, [activeTabIdRef, openTabsRef, scopeRef, storageOwnerRef])
}
